module.exports = __webpack_public_path__ + "static/media/pec_machine.f0bc80dc.png";